import React, { useEffect, useRef, useState } from "react";
import clock from '../assets/images/clock.svg'
import useAxios from "../utils/useAxios";
import { useQuery, useMutation } from "react-query";
import IP from "../variable";

import { formatTime } from "../utils/formatTime";
import toast from "react-hot-toast";

import { Modal, Input, Button, Label, Spinner, ModalHeader, ModalBody, ModalFooter } from "reactstrap";


const MyMeetings = () => {


    let api = useAxios()


    const { isLoading, isError, error, data, isSuccess, refetch } = useQuery(
        "my-meetings",
        async () => api.get(`${IP}/company/investor-meetings`),
        { cacheTime: 0 }
    );

    const myMeetings = data?.data?.meetings ?? []


 

    return (
        <>
            <div className="table-header">
                You Are Booked For
            </div>

            {
                isLoading ?

                    <div className="placeholder-wave">
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>
                        <span className="custom-card placeholder placeholder-lg col-12 mb-2"></span>

                    </div>
                    :

                    myMeetings.length > 0 ?
                    myMeetings.map((meeting) => (

                        <div className="custom-card">

                            <div className="col-4">
                              <span className="main-text" 
                              style={{ 
                                display: 'block',
                                whiteSpace: 'nowrap', 
                                overflow: 'hidden', 
                                textOverflow: 'ellipsis',
                                width: '100%'
                                }}>
                                
                                {meeting.company}
                                
                                </span>


                                <div style={{ fontSize: '0.5rem' }}>Day {meeting?.day}</div>
                                <div style={{ fontSize: '0.5rem' }}>{formatTime(meeting?.start_time)} - {formatTime(meeting?.end_time)}</div>
                            </div>
                          
                          
                            <div className="col-4 d-flex justify-content-center">
                                <span className="highlight">
                                    {meeting.location}
                                </span>
                            </div>


                            <div className="col-4 text-end" style={{visibility: 'hidden'}}>

                                <button  className="cancel-btn">
                                    Cancel
                                </button>
                                <br />
                                <div className="before-text">Before 8<sup>th</sup> Sep @ 23:59</div>
                                <div class="modal" tabindex="-1">


                            </div>
                            </div>
                        </div>
                    ))    
                    :
                     <div className="text-center">
                        <p>No Records Found</p>
                    </div> 
            }

        </>
    )
}


export default MyMeetings;